// removed by extract-text-webpack-plugin
module.exports = {"root":"_1l1HO_1l","time":"_3hAPQ_3h","updateMessage":"_3P_Kc_3P","event":"_3mqLe_3m","dots":"rn0ni_rn","status":"DbctK_Db","location":"_2hT4u_2h"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Parcel/components/History/HistoryTable/HistoryTable.css
// module id = 769
// module chunks = 0